import PageShell from "@/components/feature/PageShell";
import FeedbackForm from "./components/FeedbackForm";

const sections = [
  {
    icon: "ri-focus-3-line",
    title: "网站定位",
    content:
      "“年轻的母亲”影视专题站是一个面向剧集观众与影视爱好者的内容门户。我们不做资讯的堆砌，而是围绕这一部剧，把剧情、人物与幕后整理成一条清晰、可以随时回看的内容线。",
  },
  {
    icon: "ri-stack-line",
    title: "内容范围",
    content:
      "站内内容主要分为三类：剧情介绍（按季与集数梳理分集梗概与解读）、演员名单（主要演员与角色资料）、精彩片段（剧情回顾、精彩对白与幕后花絮）。所有剧情、演员与片段内容相互对应，方便你顺着线索一路看下去。",
  },
  {
    icon: "ri-guide-line",
    title: "使用说明",
    content:
      "你可以通过顶部导航或左侧栏目进入不同板块；在任何页面点击顶部的搜索按钮，输入剧名、演员或片段关键词即可快速定位。分类页支持按章节、首字母、角色类型与片段类型筛选，并提供排序与分页。收藏功能保存在你的本机浏览器中，不会上传后台。",
  },
  {
    icon: "ri-copyright-line",
    title: "版权声明",
    content:
      "本站为影视专题演示站，剧情、演员与片段文字均为虚构示例，仅用于展示与交流，不代表真实剧集信息。视频播放与分享功能均为前端演示，未接入真实视频源与第三方平台接口。",
  },
];

export default function AboutPage() {
  return (
    <PageShell active="about" crumbs={[{ label: "首页", to: "/" }, { label: "关于本站" }]}>
      <header className="overflow-hidden rounded-lg border border-background-200/70 bg-background-50">
        <div className="bg-primary-500 px-5 py-8 md:px-8 md:py-10">
          <h1 className="font-heading text-2xl font-semibold text-background-50 md:text-3xl">关于本站</h1>
          <p className="mt-3 max-w-2xl text-sm leading-relaxed text-primary-100">
            一个专注“年轻的母亲”这部剧的专题内容站，陪你把剧情、人物与幕后看得更清楚一些。
          </p>
        </div>
      </header>

      <div className="mt-6 grid gap-4 md:grid-cols-2">
        {sections.map((section) => (
          <section key={section.title} className="rounded-lg border border-background-200/70 bg-background-50 p-5 md:p-6">
            <div className="flex items-center gap-3">
              <span className="flex h-10 w-10 items-center justify-center rounded-lg bg-primary-50 text-xl text-primary-600">
                <i className={section.icon}></i>
              </span>
              <h2 className="font-heading text-base font-semibold text-foreground-900">{section.title}</h2>
            </div>
            <p className="mt-3 text-sm leading-loose text-foreground-600">{section.content}</p>
          </section>
        ))}
      </div>

      <div className="mt-6">
        <FeedbackForm />
      </div>
    </PageShell>
  );
}